export const DRAFT = "DRAFT";
export const PAID = "PAID";
export const SENT = "SENT";
export const PARTIALLY_PAID = "PARTIALLY_PAID";
